import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import UserEventGate from "@/components/UserEventGate";
import { mobileModeEnabled } from "@/mobile/mobileNavigation";

const Loading = () => (
  <div
    className="min-h-screen flex items-center justify-center"
    style={{ background: "var(--kd9-bg)" }}
    data-testid="auth-guard-loading"
  >
    <div className="font-cinzel kd9-gold-text tracking-[0.3em] text-sm">KD9...</div>
  </div>
);

/** Protege cualquier subárbol que requiera una sesión real del backend. */
const AuthGuard = ({ children }) => {
  const { ready, user, blocked } = useAuth();
  const location = useLocation();

  if (!ready) return <Loading />;
  if (blocked) return <Navigate to="/cuenta-bloqueada" replace />;
  if (!user) return <Navigate to={mobileModeEnabled() ? "/movil/login" : "/login"} replace state={{ from: location.pathname }} />;
  return <UserEventGate>{children}</UserEventGate>;
};

/**
 * Protege rutas sensibles con los permisos entregados por /api/me/access-map.
 * Así una URL escrita manualmente no expone pantallas de otro rol.
 */
export const PermissionGuard = ({ children, anyOf = [], allOf = [] }) => {
  const { ready, user, accessMap, blocked } = useAuth();
  const location = useLocation();

  if (!ready) return <Loading />;
  if (blocked) return <Navigate to="/cuenta-bloqueada" replace />;
  if (!user) return <Navigate to={mobileModeEnabled() ? "/movil/login" : "/login"} replace state={{ from: location.pathname }} />;

  const granted = new Set(accessMap?.permissions || []);
  const anyAllowed = anyOf.length === 0 || anyOf.some((permission) => granted.has(permission));
  const allAllowed = allOf.every((permission) => granted.has(permission));

  if (!anyAllowed || !allAllowed) {
    return <Navigate to="/app/inicio" replace state={{ denied: location.pathname }} />;
  }
  return children;
};

export default AuthGuard;
